import { render, staticRenderFns } from "./Xplay.vue?vue&type=template&id=3828e6da"
import script from "./Xplay.vue?vue&type=script&lang=js"
export * from "./Xplay.vue?vue&type=script&lang=js"
import style0 from "./Xplay.vue?vue&type=style&index=0&id=3828e6da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports